module.exports = __webpack_public_path__ + "img/logoBlue.1950255f.png";